import classes from './Footer.module.css';

const Footer = () => {
   return (
      <div className={classes.footer}>
         Copyright &copy; 2022 Evgeny Prozorov. All rights resereved.
      </div>
   )
};

export default Footer;